import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import MLCallbackPage from './pages/MLCallbackPage';
import {} from './pages/StubPages';
import ConfiguracionPage from './pages/ConfiguracionPage';
import CostosPage from './pages/CostosPage';
import RentabilidadPage from './pages/RentabilidadPage';
import InventarioPage from './pages/InventarioPage';
import AnalyticsPage from './pages/AnalyticsPage';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#0c0c0c' }}>
      <div style={{ color:'#a3e635', fontSize:14 }}>Cargando...</div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
};

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{
        style: { background:'#1a1a1a', color:'#fff', border:'1px solid rgba(255,255,255,0.1)' },
        success: { iconTheme: { primary:'#a3e635', secondary:'#111' } }
      }} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/ml-callback" element={<MLCallbackPage />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="costos" element={<CostosPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="rentabilidad" element={<RentabilidadPage />} />
          <Route path="inventario" element={<InventarioPage />} />
          <Route path="configuracion" element={<ConfiguracionPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
